import { useTranslation } from "react-i18next";

export default function SpoedService() {
  const { t } = useTranslation("slotenmaker-eindhoven");
  const points = t("spoed.points", { returnObjects: true }) as string[];

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight mb-6 md:mb-8">
              {t("spoed.h2")}
            </h2>
            <p className="font-geist text-base md:text-lg text-brand-text/70 leading-relaxed mb-8">
              {t("spoed.intro")}
            </p>
            <ul className="flex flex-col gap-4">
              {points.map((point, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-brand-yellow/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line w-4 h-4 flex items-center justify-center text-brand-text text-sm"></i>
                  </span>
                  <span className="font-geist text-sm md:text-base text-brand-text/80 leading-relaxed">
                    {point}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div className="relative rounded-2xl overflow-hidden h-[320px] md:h-[420px]">
            <img
              src="/img/63-professional-locksmith-emergency-van.jpg"
              alt="Slotenmaker spoedservice Eindhoven 24/7"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur-sm rounded-xl p-4 border border-brand-border/40">
              <p className="font-geist text-sm text-brand-text font-semibold">
                {t("spoed.note")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}